/*
 *
 * ApiKeys constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/APIKeys';

export const DEFAULT_ACTION = 'app/ApiKeys/DEFAULT_ACTION';

export const FETCH_API_KEYS = `${BASE_ACTION_CONSTANT}/FETCH_API_KEYS`;
export const SAVE_FETCH_API_KEYS_RESPONSE = `${BASE_ACTION_CONSTANT}/SAVE_API_KEYS_RESPONSE`;

export const GENERATE_API_KEY = `${BASE_ACTION_CONSTANT}/GENERATE_API_KEY`;
export const SAVE_GENERATE_API_KEY_RESPONSE = `${BASE_ACTION_CONSTANT}/SAVE_GENERATE_API_KEY_RESPONSE`;
export const GENERATE_API_KEY_URL = {
  url: '/pg/merchantkey',
  method: 'POST',
};

export const RESET_API_KEY = `${BASE_ACTION_CONSTANT}/RESET_API_KEY`;
export const SAVE_RESET_API_KEY_RESPONSE = `${BASE_ACTION_CONSTANT}/RESET_API_KEY_RESPONSE`;
export const RESET_API_KEY_URL = {
  url: '/pg/merchantkey/$app_id$',
  method: 'PATCH',
};

export const GET_API_KEY_BY_APP_ID = `${BASE_ACTION_CONSTANT}/GET_API_KEY_BY_APP_ID`;
export const SAVE_GET_API_KEY_BY_APP_ID_RESPONSE = `${BASE_ACTION_CONSTANT}/SAVE_GET_API_KEY_BY_APP_ID_RESPONSE`;
export const GET_API_KEY_BY_APP_URL = {
  url: '/pg/merchantkey/$app_id$',
  method: 'GET',
};

export const RESET_RESPONSE = `${BASE_ACTION_CONSTANT}/RESET_RESPONSE`;

export const UPDATE_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_TABLE_DATA`;

export const SET_ACTIVE_NAVIGATION = `${BASE_ACTION_CONSTANT}/SET_ACTIVE_NAVIGATION`;

export const API_CTA = `${BASE_ACTION_CONSTANT}/GENERATE_API_KEY`;

export const HEADINGS = [
  {
    key: 'generatedOn',
    displayName: 'Generated At',
    width: 1,
  },
  {
    key: 'appId',
    displayName: 'App ID (x-client-id)',
    width: 2,
  },
  {
    key: 'secretKey',
    displayName: 'Secret Key (x-secret-key)',
    width: 4,
  },
  {
    key: 'apiKeysCta',
    displayName: '',
    width: 2,
  },
];

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const MENU_ITEMS = [
  {
    key: 'VISIBILITY',
    text: 'View API Key',
    value: 'VIEW_API_KEY',
  },
  { key: 'RETRY', text: 'Reset API Key', value: 'RESET_API_KEY' },
];
